import type { IconName } from '@zen/Styleguide';

export type Score = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export interface ScoreHintLabels {
  negative: string;
  positive: string;
}

export const getIconConfig = (score: Score): { className: string; icon: IconName } => {
  if (score < 7) {
    return {
      icon: 'zicon-smile-sad',
      className: 'text-red-base'
    };
  }

  if (score === 7 || score === 8) {
    return {
      icon: 'zicon-smile-neutral',
      className: 'text-orange-base'
    };
  }

  return {
    icon: 'zicon-smile-happy',
    className: 'text-green-base'
  };
};
